export default __webpack_public_path__ + "static/media/algem-1.a69f6be3.png";